export default `<!-- SparkLayer product detail page script-->
<spark-pdp mode-all-variants parent-id="<?php echo absint( $product->get_id() ); ?>"></spark-pdp>
<!-- Hide any element by adding data-spark="b2c-only" to it, e.g. -->
<div data-spark="b2c-only">
    <!-- This would hide anything inside-->
</div>
`;
